import { createContext } from '@costar-ui/utils'
import type { FC, PropsWithChildren } from 'react'
import React, { useMemo } from 'react'

import type { TableContext } from './types'

const [TableProvider, useTableContext] = createContext<TableContext>({
  name: 'Table Context'
})

const TableContextProvider: FC<PropsWithChildren<TableContext>> = props => {
  const {
    direction,
    fillContainer,
    resizableColumn,
    stickyHeader,
    stickyColumns,
    stickyFooter,
    children
  } = props
  const context = useMemo(
    () => ({
      direction,
      fillContainer,
      resizableColumn,
      stickyHeader,
      stickyColumns,
      stickyFooter
    }),
    [
      direction,
      fillContainer,
      resizableColumn,
      stickyHeader,
      stickyColumns,
      stickyFooter
    ]
  )
  return <TableProvider value={context}>{children}</TableProvider>
}
export default TableContextProvider
export { useTableContext }
